<template>
    <div v-if="!isLoading" class="pt-5" id="grid">
      <!-- <div class="text-center my-3">
        <img :src="streamFileUrl + workspace.operatingCenterLogo" alt="" class="rounded-circle" style="width: 15rem; height: 15rem">
      </div> -->
      <div class="text-center my-3">
        <h3 class="text-warning text-uppercase">{{ workspace.operatingCenterName }}</h3>
      </div>
      <img src="https://db.sadec.dongthap.gov.vn/img/logo-tpcl.de32279c.png" id="logo"/>
      <div>
        <router-link v-for="report in reports" :key="report.id" :to="'/report-viewer?reportId=' + report.id" target="_blank" size="sm" class="">
          <div class="button d-flex justify-content-center align-items-center">
            <img :src="(report.imageUrl != null && report.imageUrl.trim().length > 0 ) ? streamFileUrl + report.imageUrl : require('@/assets/default-report.png')" class="image"/>
            <span class="text">{{ report.reportName }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <Loading :active="isLoading" class="text-center" color="#000000" loader="spinner"></Loading>
</template>
  
<script>
import $ from 'jquery';
import {mapActions} from 'vuex';
import config from '@/config/prod.env';
import Loading from "vue3-loading-overlay";
export default {
    name: "TheOperatingCenter2",
    components: {
      Loading
    },
    data() {
      return {
        isLoading: true,
        workspaceId: null,
        workspace: null,
        streamFileUrl: null,
        reports: [],
      }
    },
    methods: {
      ...mapActions('report', ['getActiveReportByWorkspaceId']),
      ...mapActions('workspace', ['getWorkspaceById', 'getWorkspaceByRoleIds']),
      setup() {
        this.streamFileUrl = process.env.VUE_APP_STREAM_FILE_URL;
        this.workspaceId = this.$route.query.workspaceId;
      },
      async getData() {
        // get workspace
        let rs1 = await this.getWorkspaceById(this.workspaceId);
        if(rs1.isOk) {
          this.workspace = rs1.data.data;

          // check permission
          let user = JSON.parse(localStorage.getItem('login_info'));
          let roleIds = user.roleInfo.map(e => e.id);
          let rs = await this.getWorkspaceByRoleIds(roleIds);
          if(rs.isOk) {
            let workspaceIds = rs.data.data.map(e => e.id);
            if(!workspaceIds.includes(this.workspaceId)) {
              this.$router.push("/admin");
            }
          } else {
            this.$router.push("/admin");
          }

          // check isUsePBIHome
          // if(this.workspace.isUsePBIHome) {
          //   this.$router.push(`/report-viewer?reportId=${this.workspace.reportId}`);
          // }
        }

        // get reports
        let rs2 = await this.getActiveReportByWorkspaceId(this.workspaceId);
        if(rs2.isOk) {
          this.reports = rs2.data.data;
        }
        this.isLoading = false;
      }
    },
    async mounted() {
      this.setup();
      await this.getData();

      let deg = 360 / this.reports.length;
      let init = 0;
      $('#grid div .button').each(function() {
          $(this).css("transform", `rotate(${init}deg) translate(0px, -17rem) rotate(-${init}deg)`);
          if(init === 0) {
              $(this).children('.text').css('top', '-2.5rem');
              $(this).children('.text').css('left', '-7rem');
              $(this).children('.text').css('text-align', 'center');
          } else if (init === 180) {
              $(this).children('.text').css('bottom', '-4.5rem');
              $(this).children('.text').css('left', '-7rem');
              $(this).children('.text').css('text-align', 'center');
          } else if (init < 180) {
              $(this).children('.text').css('top', '1.5rem');
              $(this).children('.text').css('left', '6rem');
              $(this).children('.text').css('text-align', 'left');
          } else if (init > 180) {
              $(this).children('.text').css('top', '1.5rem');
              $(this).children('.text').css('right', '7rem');
              $(this).children('.text').css('text-align', 'right');
          }
          
          init += deg;
      });
      
    },
    created() {
     
    }
};
</script>
  
<style lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  /* GRID 5 */
  #grid {
    width: 100vw;
    height: 100vh;
    // background-image: url('@/assets/bg.png');
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: cover;
    position: relative;
  }
  #grid #logo {
    width: 15rem;
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -7.5rem -7.5rem;
  }
  #grid .button {
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -2.25rem -2.25rem;
    background: linear-gradient(180deg, #4447c8 0%, rgb(54, 62, 192) 50%, #2d2271 100%);
    box-shadow: 0px 2px 5px #2958cc;
    /* transform: translate(-30px, -30px); */
  }
  #grid .button .image {
    width: 60%;
    // position: absolute;
    // top: 18%;
    // left: 20%;
  }
  #grid .button .text {
    position: absolute;
    /* top: -30px; */
    color: white;
    font-size: 1.3rem;
    width: 300px;
  }

  #grid .button:hover {
    box-shadow: 0px 5px 5px 5px black;
    background-color: #125e97;
    transition: all .5s;
    cursor: pointer;
  }
</style>